<script setup lang="ts">
import AppAvatar from "@/components/common/AppAvatar.vue";
import AppTextTooltip from "@/components/common/AppTextTooltip";
import NavBarStatus from "@/components/workspace/NavBarStatus.vue";
import { mdiCheckCircleOutline, mdiCloseCircleOutline } from "@mdi/js";
import { Button, Icon } from "@soft-db/ui";
import { ItemObject } from "./use-drawer-data";

defineProps({
	item: { type: Object as PropType<ItemObject>, required: true },
});
const emit = defineEmits(["select"]);

function select(item: ItemObject) {
	emit("select", item);
}

const route = useRoute();
function isActive(item: ItemObject) {
	if (route.path.includes("map")) {
		let query = { ...route.query };
		return query.id && query.id === item.id;
	}

	if (
		route.path.includes("dashboard") ||
		route.path.includes("spaces") ||
		route.path.includes("reports")
	) {
		return route.params.id && route.params.id === item.id;
	}

	if (route.path.includes("integrity")) {
		if (route.path.includes("sites") && item.object === "site") {
			return route.params.id && route.params.id === item.id;
		} else if (route.path.includes("stations") && item.object === "station") {
			return route.params.id && route.params.id === item.id;
		}
	}

	if (!route.path.includes("integrity")) {
		if (route.path.includes("sites")) {
			return route.params.id && route.params.id === item.id;
		} else if (route.path.includes("stations")) {
			return route.params.id && route.params.id === item.id;
		}
	}

	return false;
}
</script>

<template>
	<Button
		class="flex min-h-12 w-full flex-row items-center justify-start gap-2 rounded-2xl"
		:class="isActive(item) ? 'bg-primary/20' : ''"
		variant="outline"
		@click="select(item)"
	>
		<NavBarStatus
			v-if="item.object === 'site' || item.object === 'station'"
			:sourceType="item.object"
			:sourceId="item.id"
		/>
		<AppAvatar v-else-if="item.object === 'space'" class="size-6" :src="item.image" />
		<div class="flex flex-col items-start">
			<AppTextTooltip class="max-w-56" as="h4" :value="item.name" />
			<AppTextTooltip class="max-w-56 text-xs font-medium" :value="item.description" />
		</div>
		<Icon
			v-if="item.object === 'report'"
			class="ml-auto"
			:class="item.connected ? 'text-success' : 'text-error'"
			:d="item.connected ? mdiCheckCircleOutline : mdiCloseCircleOutline"
		/>
	</Button>
</template>
